export const NAME = 'templates';
